import React, { useEffect, useState } from 'react';
import { getdata, updatedata } from "../../util/global";
import SettingForm from './SettingForm';

const AppointmentSetting = () => {
  const [usersetting, setusersetting] = useState({});
  const [mode, setmode] = useState("");

  const fetchdata = async () => {
    try {
      const u = await getdata({ filter: { "datatype": "usersettingdata" } });
      if (u.length > 0) {
        setusersetting(u[0]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const openusersettingform = () => {
    setmode("showusersettingform");
  };

  const updateusersetting = async () => {
    try {
      // This ensures that if the config is a string, it's parsed, and if it's an object, it's cloned.
      if (typeof usersetting.config === 'string') {
        usersetting.config = JSON.parse(usersetting.config);
      } else {
        usersetting.config = JSON.parse(JSON.stringify(usersetting.config));
      }
    } catch (ex) {
      console.log(ex);
      alert("Invalid JSON format in settings.");
      return false;
    }

    usersetting.datatype = "usersettingdata";
    const payload = { data: usersetting };

    await updatedata(payload);
    await fetchdata();
    setmode("");
  };

  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <div className="content-area">
       <div className="table-header-row">
        <h1 className="dash-title">
          Settings
        </h1>
      </div>
      <a href={"#"} onClick={(e) => { e.preventDefault(); openusersettingform(); }}>
        User Settings
      </a>
      <p className="muted-sm">Configure user-level settings and schedulers.</p>

      <SettingForm
        mode={mode}
        setmode={setmode}
        config={usersetting}
        updateconfig={updateusersetting}
        setconfig={setusersetting}
        title="User Setting"
      />
    </div>
  );
};

export default AppointmentSetting;

